module.exports = __webpack_public_path__ + "static/media/country_tr.68d55c66.webp";